const Form100TC = {
    stepName: {
        importantNotes: "重要事項",
        selectType: "選擇類型",
        schoolInformation: "學校信息",
        applicantBodyInformation: "辦學團體資料",
        eligibilityRequirement: "申請資格",
        locationPreference: "屬意地點",
        documentUpload: "文檔上傳",
        successfulObligations: "成功的辦學團體的責任",
        confirmation: "確認",
    },
    label: {
        year: "年份：",
        yearPage: "年份",
        type: "工作類型：",
        typeOptions: {
            A: "重置小學",
            B: "重置中學",
            C: "重置小學及中學",
            D: "營辦一所特殊學校",
            E: "營辦一所附設宿舍的特殊學校",
            F: "有時限性擴充小學／中學校舍",
            G: "營辦全新有時限性小學／中學",
            H: "營辦全新小學／中學",
            I: "小學／中學校舍擴充",
        },
        exercisePeriod: "工作期間：",
        to: "至：",
        no: "編號：",
        title: "表單標題：",
        districtTitle: "標題中的地區：",
        itemNo: "項目編號：",
        location: "地點：",
        locationItemNoAndLocation: "場地/場地編號和地點",
        addExercise: "添加工作",
        declaration: "本人已閱讀「個人資料收集聲明」及完全明白其內容。",
        exerciseType: "校舍分配工作種類",
        districtOrPlace: "校舍位置",
        noInPdfTitle: "SAE編號",
        copies: "一式份數",
        pages: "提交檔案份數",
        noInEformTitle: "Eform標題中的編號",
        noOfPremisesAvailable: "可用的房舍數量：",
        pdfLink: "最新的義務PDF的鏈接：",
        schoolNameEn: "學校名稱（英文）",
        schoolNameCn: "學校名稱（中文）",
        schoolAddressEn: "學校地址（英文）",
        schoolAddressCn: "學校地址（中文）",
        financeType: "資助種類",
        applicantBodyEn: "辦學團體的註冊名稱（英文）",
        applicantBodyCn: "辦學團體的註冊名稱（中文）",
        correspondenceAddressEn: "通訊地址（英文）",
        correspondenceAddressCn: "通訊地址（中文）",
        titleEn: "稱謂（英文）",
        titleCn: "稱謂（中文）",
        contactNameEn: "聯絡人姓名（英文）",
        contactNameCn: "聯絡人姓名（中文）",
        positionEn: "職位（英文）",
        positionCn: "職位（中文）",
        telNo: "電話號碼",
        faxNo: "傳真號碼",
        email: "電郵地址",
        contactPersonInformation: "聯絡人信息",
        isRegisteredOrdinance: "辦學團體是否按《公司條例》(第622章)註冊成立？",
        specifyOrdinance: "請註明辦學團體是按哪條條例於香港註冊成立",
        isExemptOrdinance:
            "辦學團體是否根據《稅務條例》(第112章)第88 條獲得豁免繳稅？",
        yesOrNo: {
            yes: "是",
            no: "否",
        },
        indicatePreference: "請於以下位置按次序表明屬意地點–",
        locationSelectType: "種類",
        locationItemNo: "項目編號",
        locationLocation: "位置",
        locationPriority: "優先次序",
        documentsChecklist: "所需文件核對清單",
        allocatedCommitted: "如獲分配校舍， 辦學團體須承諾會：",
        allocatedCommittedNote: {
            a: "推行各項教育局推廣的教育措施；",
            b: "交回現有校舍。如現有校舍座落於辦學團體或該校或與辦學團體／該校有關的第三者所擁有的私人土地上，辦學團體須承諾會確保於獲分配新校舍後，把現有學校的用地連同其上的所有建築物及構築物將在不受產權負擔及任何申索、訴訟、法律程序及法律責任(無論是以逆權管有或以其他形式)影響和無須費用及補償之下一併交回香港特區政府；及",
            c: "於政府指定時間內，就校舍的使用與政府簽訂租約，並簽訂服務合約，以供當局監控服務質素和確保相關教育政策得以遵行。",
        },
        allocatedCommittedCheckText:
            "我確認我已閱讀、明白及同意遵從上述成功申請的辦學團體的責任",
        EDBDeclaration: "教育局的聲明",
        applicationNature: "申請及提交辦學計劃書屬非約束性",
        EDBDeclarationText:
            "邀請有關團體提出申請及提交詳細辦學計劃書一事屬非約束性，既不會對任何一方構成有關校舍分配的任何形式的要約或作出任何形式的要約的依據，亦不會令政府負上任何法律義務；同時不會妨礙校舍分配委員會／政府日後進行的審查，亦不會迫使政府必須採取任何行動，包括批准或不批准任何校舍分配，不論已接獲的申請數目多寡。這次邀請並不會迫使政府必須把校舍於任何時間內分配予任何有關方面。",
        responsiblePerson: "辦學團體負責人",
        responsiblePersonNameEn: "辦學團體負責人的姓名（英文）",
        responsiblePersonNameCn: "辦學團體負責人的姓名（中文）",
        responsiblePersonPosition: "職位",
        responsiblePersonOrganisation: "機構",
        obligationLink: "查看最新的義務PDF的鏈接",
        titleEnOp: {
            Mr: "Mr",
            Mrs: "Mrs",
            Ms: "Ms",
            Miss: "Miss",
        },
        titleCnOp: {
            Mr: "先生",
            Mrs: "太太",
            Ms: "女士",
            Miss: "小姐",
        },
        financeTypeOp: {
            Aided: "資助",
            Caput: "按位津貼",
            Direct: "直接資助計劃",
            Private: "私立",
            Others: "其他",
        },
        otherRemark: "請備註",
        eligibleSchoolType: "合資格申請學校類型",
        allocationType: "分配類型",
        allocationTypeOp: {
            Premises: "校舍",
            Site: "校址",
        },
        allocationNo: "校舍分配工作編號",
    },
    documentsChecklistMsg: {
        one: "1. <u>若辦學團體按《公司條例》註冊成立</u>，請提供辦學團體的公司註冊文件及其組織章程細則，並請填寫本表格的",
        oneA: "附頁I",
        oneB: "。",
        two: "2. <u>若辦學團體按其條例註冊成立</u>，請提供有關條例的內容，及其章程（如有）。",
        three: "3. 辦學團體的免稅證明書。",
        four: "4. 上載下列文件：",
        fourA: "(i) 辦學計劃書（連同所有附件不超過 {{pages}} 頁",
        fourB: "）、(ii) 摘要（不超過兩頁",
        fourC: "）及(iii) 現時營辦學校一覽表（請列明學校名稱、地址及所屬類別）。",
        five: "5. 我明白我須向教育局提交一式{{copies}}份下列文件：",
        fiveA: "(i) 辦學計劃書（連同所有附件不超過 {{pages}} 頁<sup>#</sup>）、(ii) 摘要（不超過兩頁<sup>#</sup>）及(iii) 現時營辦學校一覽表（請列明學校名稱、地址及所屬類別）。",
        six: "6. 現有校舍設施、狀況及土地類別／樓宇性質、班級結構及入讀人數調查表格（本表格的",
        sixA: "附頁II",
        sixB: "）。",
        seven: "7. 班級結構及入讀人數調查表格（本表格的",
        sevenA: "附頁II",
        sevenB: "）。",
        eight: "8. 若現時校舍座落於辦學團體或該校或與辦學團體／該校有關的第三者所擁有的私人土地上，請提供業權詳情及有關記錄，包括但不限於業權契據、土地／租賃協議及有關的平面圖、經土地註冊處認證最近期的業權記錄、令狀、傳票、押記令、由政府或其他主管機關發出之通告命令等（只適用於申請重置現有學校）。",
        nine: "9. 證明校方就重置／擴充計劃（以適用者為準）已諮詢家長及教師的有關文件及其對重置計劃／擴充（以適用者為準）意見的資料。請提供有關諮詢的規模／方式等資料，例如發出及收回的問卷數目等。",
    },
    tooltipMsg: {
        schoolInformation: "申請必須由申請重置的學校的註冊辦學團體提交。",
        applicantBodyInformation:
            "辦學團體必須為註冊辦學團體， 並符合有關申請資格。",
        eligibilityRequirement: "請留意《填表須知》第一項有關申請資格的內容。",
        locationPriority:
            "請填寫屬意地點的優先次序，以「1」代表首選。辦學團體可選擇最多{{premisesAvailable}}間校舍， 而最少應選擇1間校舍。所有申請均會由校舍分配委員會審核， 審核申請時，辦學團體的選擇次序會列作考慮因素。如沒有填寫任何優先次序，或所填寫的資料不能清楚顯示辦學團體所揀選的優先次序，有關申請或不會受理。於是次校舍分配工作，政府並非必須把校舍分配予任何有關方面，或按辦學團體屬意地點的優先次序而作分配。",
        documentsChecklist: "載於超過頁數限制的頁面內容將不被考慮",
    },
    errorMsg: {
        repeatData: "請輸入不重複的{{item}}",
    },
    expiredMessage:
        "現時並沒有可供申請的校舍分配工作。有關校舍分配工作的最新消息，請參閱本局網頁：",
    tips: {
        note: "填寫本表格前請細閱《填表須知》。",
        noteTwo:
            "如辦學團體希望申請多於一個校舍／校址（以適用者為準），請按「增加」。",
    },
};

export default Form100TC;
